import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import StaticPage from '../../components/StaticPage';

export default function PressPage() {
    return (
        <StaticPage title="Press" subtitle="Media inquiries and brand assets.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    The Creator Match is a marketplace connecting brands with creators, with AI-assisted search and
                    matching built in. If you're writing about the creator economy or influencer marketing
                    tools and want a quote, a demo, or more background, get in touch through the{' '}
                    <Link component={RouterLink} to="/contact" color="secondary.main">Contact</Link> page.
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    We don't have press coverage or brand assets published yet — this page will be updated
                    as that changes.
                </Typography>
            </Box>
        </StaticPage>
    );
}
